import { supabase } from './supabase.js';

/** URL de avatar usable en `<img src>` (http/https o path absoluto). */
export function resolveProfileAvatarUrl(url) {
  const s = typeof url === 'string' ? url.trim() : '';
  if (!s) return null;
  if (/^https?:\/\//i.test(s) || s.startsWith('//') || s.startsWith('/')) return s;
  return null;
}

/** Iniciales para avatar (username o nombre visible). */
export function profileInitials(usernameOrName) {
  const s = String(usernameOrName || '?').trim().replace(/^@/, '');
  if (!s) return '?';
  const parts = s.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return s.slice(0, 2).toUpperCase();
}

/**
 * Mapa profile id → avatar_url para un lote de ids.
 * @param {string[]} profileIds
 * @returns {Promise<Record<string, string|null>>}
 */
export async function fetchAvatarUrlMap(profileIds) {
  const ids = [...new Set((profileIds || []).filter(Boolean))];
  if (!ids.length) return {};
  const { data, error } = await supabase.from('profiles').select('id, avatar_url').in('id', ids);
  if (error) {
    console.warn('[profileAvatar] fetchAvatarUrlMap:', error.message);
    return {};
  }
  return Object.fromEntries((data || []).map(p => [p.id, resolveProfileAvatarUrl(p.avatar_url)]));
}

/**
 * Rellena `avatar_url` en filas que vienen de RPC u otras fuentes sin avatar.
 * @param {Array<Record<string, unknown>>} rows
 * @param {string} [idKey='id']
 */
export async function enrichRowsWithProfileAvatars(rows, idKey = 'id') {
  if (!Array.isArray(rows) || !rows.length) return rows;
  const needIds = rows.filter(r => !resolveProfileAvatarUrl(r?.avatar_url)).map(r => r[idKey]).filter(Boolean);
  if (!needIds.length) return rows;
  const map = await fetchAvatarUrlMap(needIds);
  return rows.map(r => {
    const id = r[idKey];
    const existing = resolveProfileAvatarUrl(r.avatar_url);
    return { ...r, avatar_url: existing ?? map[id] ?? null };
  });
}
